





















































































import Vue from 'vue';
import store from '../store/store';
import _ from 'lodash';
import 'intro.js/introjs.css';
import {
  mapState,
  mapActions
} from 'vuex';
import {
  HeaderData
} from '../types/common';
import introJs from 'intro.js';

export default Vue.extend({
  name: 'Header',
  data(): HeaderData {
    return {
      isShowDetail: false,
      isShowIp: false,
      title: 'IP范围',
      isShowVersion: false,
      version: {
        features: '',
        versionNo: '',
        updateTime: ''
      }
    };
  },
  computed: mapState({
    userInfo: (state: any) => store.getters.getUserInfo,
    // permission: (state: any) => store.getters.getPermission,
    menuIndex: (state: any) => store.getters.getMenuIndex,
    checkHomeUrl: (state: any) => store.getters.getCheckHomeUrl,
    logoutUrl: (state: any) => store.getters.getLogoutUrl,
    paperType: (state: any) => store.getters.getPaperType,
    checkType: (state: any) => store.getters.getCheckType
  }),
  methods: {
    // 跳转检测首页
    toCheckHome() {
      window.location.href = this.checkHomeUrl;
    },
    // ip详情
    ipDetail(mark: boolean, title: string) {
      this.isShowIp = mark;
      this.title = title;
    },
    // 版本详情
    versionDetail(mark: boolean) {
      this.isShowVersion = mark;
    },
    getVersion() {
      this.$http.get('/api/System/GetVersion').then((data: any) => {
        this.version = data.data;
      });
    },
    // 退出登录
    signOut() {
      window.location.href = this.logoutUrl;
    }
  },
  mounted() {
    this.getVersion();
  }
});
